import { render, staticRenderFns } from "./SettingsExternalPlugin.vue?vue&type=template&id=5bfa6adb&scoped=true&"
import script from "./SettingsExternalPlugin.vue?vue&type=script&lang=js&"
export * from "./SettingsExternalPlugin.vue?vue&type=script&lang=js&"
import style0 from "./SettingsExternalPlugin.vue?vue&type=style&index=0&id=5bfa6adb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa6adb",
  null
  
)

export default component.exports